module.exports = __webpack_public_path__ + "img/IconOOP.7d2e90e9.svg";